export enum PaymentStatus {
  PAID = "ps111111-1111-1111-1111-111111111111",
  UNPAID = "ps222222-2222-2222-2222-222222222222",
  PARTIALLY_PAID = "ps333333-3333-3333-3333-333333333333",
  RETURNED = "ps444444-4444-4444-4444-444444444444",
}

export const PaymentStatusInfo = {
  [PaymentStatus.PAID]: { code: "paid", name: "Paid" },
  [PaymentStatus.UNPAID]: { code: "unpaid", name: "Unpaid" },
  [PaymentStatus.PARTIALLY_PAID]: {
    code: "partially_paid",
    name: "Partially Paid",
  },
  [PaymentStatus.RETURNED]: { code: "returned", name: "Returned" },
} as const;

export const getPaymentStatusCode = (value: PaymentStatus): string =>
  PaymentStatusInfo[value].code;
export const getPaymentStatusName = (value: PaymentStatus): string =>
  PaymentStatusInfo[value].name;
